import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { t } from '../hooks/useT';

interface CreditEntry {
  provider: string;
  photographer: string;
  pageUrl: string | null;
  totalLikes: number;
  puzzleCount: number;
}

const PROVIDER_LABELS: Record<string, string> = {
  pexels: 'Pexels',
  unsplash: 'Unsplash',
};

export function CreditsPage() {
  const [photographers, setPhotographers] = useState<CreditEntry[]>([]);

  useEffect(() => {
    api<{ photographers: CreditEntry[] }>('/gallery/credits')
      .then((data) => setPhotographers(data.photographers))
      .catch(() => {});
  }, []);

  return (
    <main className="page credits">
      <h1>{t('credits.title')}</h1>
      <p className="sub">{t('credits.sub')}</p>

      <ol className="credits-list">
        {photographers.map((p) => (
          <li key={`${p.provider}-${p.photographer}`}>
            {p.pageUrl ? (
              <a href={p.pageUrl} target="_blank" rel="noopener noreferrer">
                {p.photographer}
              </a>
            ) : (
              <span>{p.photographer}</span>
            )}
            <span className="credits-meta">
              {PROVIDER_LABELS[p.provider] || p.provider} · ♥ {p.totalLikes}
            </span>
          </li>
        ))}
      </ol>

      <nav className="result-nav">
        <Link to="/top">{t('nav.top')}</Link>
        <Link to="/">Accueil</Link>
      </nav>
    </main>
  );
}
